import { render, staticRenderFns } from "./TenantDetailsDialog.vue?vue&type=template&id=1fc7faca&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TenantDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./TenantDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetailsDialog.vue?vue&type=style&index=0&id=1fc7faca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc7faca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCardText,VForm,VTextField})
